import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStack32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconImageStack32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 7H11a2 2 0 0 0-2 2h12a4 4 0 0 1 4 4v7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m-2 15v-9a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6.131l4.445-2.963.643-.428.577.513L19.38 24H21a2 2 0 0 0 2-2m-3.996 4H21a4 4 0 0 0 4-4 4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H11a4 4 0 0 0-4 4 4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h12.005m-2.634-2-6.457-5.74L5 21.535V22a2 2 0 0 0 2 2zm2.13-7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStack32);
